module.exports = __webpack_public_path__ + "img/cloth_g1_sleeve_07.f84da950.svg";